"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBodyLanguage = setBodyLanguage;

function setBodyLanguage(GLOBAL, language) {
  if (!GLOBAL || !GLOBAL.document || !GLOBAL.document.body || typeof GLOBAL.document.body.setAttribute !== 'function') {
    return false;
  }

  GLOBAL.document.body.setAttribute('lang', language);
  return true;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/dist/services/language.js
// module id = 192
// module chunks = 33